import { Directive, Output, EventEmitter, HostListener, Input } from '@angular/core';

export interface Movement {
	x: number;
	y: number;
}

type Direction = 'horizontal' | 'vertical';

const IsTouchInDirection: Record<Direction, (movement: Movement) => boolean> = {
	horizontal: ({ x, y }) => Math.abs(x) > Math.abs(y),
	vertical: ({ x, y }) => Math.abs(x) < Math.abs(y),
};

@Directive({
	selector: '[cdxSwipe]',
	standalone: true,
})
export class SwipeDirective {
	@Input('cdxSwipe') desiredDirection: Direction | undefined;
	@Output() swipeLeft = new EventEmitter<void>();
	@Output() swipeRight = new EventEmitter<void>();
	@Output() swipeMove = new EventEmitter<Movement>();

	private _startX: number;
	private _startY: number;
	private readonly _threshholdX = 30;

	@HostListener('touchstart', ['$event'])
	onTouchStart(event: TouchEvent): void {
		const { clientX, clientY } = event.touches[0];
		this._startX = clientX;
		this._startY = clientY;
	}

	@HostListener('touchend', ['$event'])
	onTouchEnd(event: TouchEvent): void {
		const endX = event.changedTouches[0].clientX;
		const deltaX = endX - this._startX;

		if (Math.abs(deltaX) > this._threshholdX) {
			// Adjust the threshold as needed
			if (deltaX > 0) {
				this.swipeRight.emit();
			} else {
				this.swipeLeft.emit();
			}
		} else {
			this.swipeMove.emit({ x: 0, y: 0 });
		}
	}

	@HostListener('touchmove', ['$event'])
	onTouchMove(event: TouchEvent): void {
		const { clientX, clientY } = event.touches[0];
		const movement = { x: this._startX - clientX, y: this._startY - clientY };

		/**
		 * Sometimes we need the swipe in desired direction to be handled by host component rather than browser's
		 * default handler.
		 */
		if (this.desiredDirection && IsTouchInDirection[this.desiredDirection](movement)) {
			event.preventDefault();
		}

		this.swipeMove.emit(movement);
	}
}
